export default {
    ATENDIMENTO_DOMICILIAR: 1,
    ATENDIMENTO_INDIVIDUAL: 2,
    ATENDIMENTO_ODONTOLOGICO: 3,
    ATIVIDADE_COLETIVA: 4,
    AVALIACAO: 5,
    CADASTRO_DOMICILIAR: 6,
    CADASTRO_INDIVIDUAL: 7,
    FICHA_COMPLEMENTAR: 8,
    CONSUMO_ALIMENTAR: 9,
    PROCEDIMENTO: 10,
    FICHA_VACINACAO: 11,
    VISITA_DOMICILIAR: 12,
}